// extracted by mini-css-extract-plugin
module.exports = {"socialHeader":"Social_socialHeader__NGLbI","social":"Social_social__yUJzZ","socialItem":"Social_socialItem__I7grb","socialIcon":"Social_socialIcon__GI6oW"};